import { jsx as _jsx } from "react/jsx-runtime";
export const IconEmoji = ({ text, size, ...rest }) => {
    let shortCode = text;
    if (!text.startsWith(':')) {
        shortCode = `:${text}:`;
    }
    const emojiSize = {
        xs: 18,
        sm: 20,
        md: 22,
        lg: 32,
        xl: 64,
        '2xl': 96,
    };
    let sizeString = '1em';
    if (size && emojiSize[size]) {
        sizeString = `${emojiSize[size]}px`;
    }
    /* eslint-disable-next-line @typescript-eslint/ban-ts-comment */
    /* @ts-ignore */
    return _jsx("em-emoji", { shortcodes: shortCode, size: sizeString, ...rest }, void 0);
};
//# sourceMappingURL=IconEmoji.js.map